(function () {
  if (!('IntersectionObserver' in window)) return;

  var sections = document.querySelectorAll('#MainContent .shopify-section');
  if (!sections.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('zb-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  );

  sections.forEach(function (section, index) {
    if (index === 0) {
      section.classList.add('zb-in-view');
      return;
    }
    observer.observe(section);
  });
})();
